import { createContext, type RefObject } from "react";

export const BodyContext = createContext<RefObject<HTMLDivElement | null>>({
    current: null,
});
